/**
 * Human label for a user role key: "sub_admin" → "Sub Admin".
 * @param {string} role
 * @returns {string}
 */
export default function roleLabel(role) {
  if (!role) return "";
  return String(role)
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
